import { OptionDefinition } from "@amzn/awsui-components-console/internal/components/option/interfaces";
import { clone } from "../utils/CommonUtils";
import {
  languageOptionsModel,
  servicesAndFeaturesModel,
  verticalOptionsModel,
} from "../utils/model/staticContentModel";
import { RadioGroupProps } from "@amzn/awsui-components-console/radio-group";

export const LANGUAGES = [
  "English",
  "French",
  "German",
  "Hindi",
  "Italian",
  "Japanese",
  "Korean",
  "Portuguese",
  "Spanish",
  "Dutch",
];

export const demoTypeExternalUrl = "External URL";
export const demoTypeCloudFormation = "CloudFormation Template";
export const demoTypeInternalEditor = "Internal Editor";

export const DEMO_TYPES = [
  demoTypeInternalEditor,
  demoTypeExternalUrl,
  demoTypeCloudFormation,
];

export const DEMO_FORMATS = ["Click through", "Live environment", "Video"];

export const SERVICES_AND_FEATURES = [
  "Amazon AppStream 2.0",
  "Amazon Bedrock",
  "Amazon Connect",
  "Amazon Connect 3rd Party Apps",
  "Amazon Connect Agent Workspace",
  "Amazon Connect Analytics Data Lake",
  "Amazon Connect Capacity Planning",
  "Amazon Connect Cases",
  "Amazon Connect Chat",
  "Amazon Connect Contact Flows",
  "Amazon Connect Contact Lens",
  "Amazon Connect Customer Profiles",
  "Amazon Connect Email",
  "Amazon Connect for Apple Messages for Business",
  "Amazon Connect for WhatsApp Business",
  "Amazon Connect Forecasting",
  "Amazon Connect Forecasting, Capacity Planning, and Scheduling",
  "Amazon Connect Global Resiliency",
  "Amazon Connect Guides",
  "Amazon Connect In-App Calling",
  "Amazon Connect Integrations",
  "Amazon Connect Outbound Campaigns",
  "Amazon Connect Post Contact Summaries",
  "Amazon Connect Screen Recording",
  "Amazon Connect Screen Share",
  "Amazon Connect SMS",
  "Amazon Connect Step by Step Guides",
  "Amazon Connect Tasks",
  "Amazon Connect Telephony",
  "Amazon Connect Video Calling",
  "Amazon Connect Web Calling",
  "Amazon DynamoDB",
  "Amazon Lex",
  "Amazon Polly",
  "Amazon Q",
  "Amazon Q in Connect",
  "Amazon WorkSpaces",
  "Amazon WorkSpaces Core",
  "Amazon WorkSpaces Secure Browser",
  "AWS Lambda",
  "AWS Supply Chain",
];

export const VERTICALS = [
  "All",
  "Finance",
  "Health",
  "Hospitality",
  "Government",
  "Insurance",
  "Mining",
  "Retail",
  "Transportation",
  "Travel",
];

export const CATEGORY_OPTIONS = [
  "Demo Experience Portal",
  "Click through demo",
  "Live demo",
];

export const SUPPORTED_GROUPS = [
  "Admin",
  "Builder",
  "Partner",
  "PartnerAdmin",
  "Tester", // Provides access to beta features for testing
];

export const ROADMAP_STATUSES = [
  "Not started",
  "Planning",
  "Design",
  "Development",
  "Complete",
];

export const FEEDBACK_TYPE = [
  "General feedback",
  "Feature request or demo idea",
  "Bug report or data issue",
  "Support request",
];

type PollyVoice = {
  id: string;
  voice: string;
  language: string;
  label: string;
  defaultVoice: boolean;
  engine: string;
};

export const POLLY_VOICES: PollyVoice[] = [
  {
    id: "Amy_en-GB_neural",
    voice: "Amy",
    language: "en-GB",
    label: "Amy (British - English - Neural)",
    defaultVoice: false,
    engine: "neural",
  },
  {
    id: "Amy_en-GB_generative",
    voice: "Amy",
    language: "en-GB",
    label: "Amy (British - English - Generative)",
    defaultVoice: false,
    engine: "generative",
  },
  {
    id: "Aria_en-NZ_neural",
    voice: "Aria",
    language: "en-NZ",
    label: "Aria (New Zealand - English - Neural)",
    defaultVoice: false,
    engine: "neural",
  },
  {
    id: "Arthur_en-GB_neural",
    voice: "Arthur",
    language: "en-GB",
    label: "Arthur (British - English - Neural)",
    defaultVoice: false,
    engine: "neural",
  },
  {
    id: "Brian_en-GB_neural",
    voice: "Brian",
    language: "en-GB",
    label: "Brian (British - English - Neural)",
    defaultVoice: false,
    engine: "neural",
  },
  {
    id: "Danielle_en-US_neural",
    voice: "Danielle",
    language: "en-US",
    label: "Danielle (USA - English - Neural)",
    defaultVoice: false,
    engine: "neural",
  },
  {
    id: "Danielle_en-US_generative",
    voice: "Danielle",
    language: "en-US",
    label: "Danielle (USA - English - Generative)",
    defaultVoice: false,
    engine: "generative",
  },
  {
    id: "Emma_en-GB_neural",
    voice: "Emma",
    language: "en-GB",
    label: "Emma (British - English - Neural)",
    defaultVoice: false,
    engine: "neural",
  },
  {
    id: "Gregory_en-US_neural",
    voice: "Gregory",
    language: "en-US",
    label: "Gregory (USA - English - Neural)",
    defaultVoice: false,
    engine: "neural",
  },
  {
    id: "Joanna_en-US_neural",
    voice: "Joanna",
    language: "en-US",
    label: "Joanna (USA - English - Neural)",
    defaultVoice: false,
    engine: "neural",
  },
  {
    id: "Joanna_en-US_generative",
    voice: "Joanna",
    language: "en-US",
    label: "Joanna (USA - English - Generative)",
    defaultVoice: false,
    engine: "generative",
  },
  {
    id: "Kendra_en-US_neural",
    voice: "Kendra",
    language: "en-US",
    label: "Kendra (USA - English - Neural)",
    defaultVoice: false,
    engine: "neural",
  },
  {
    id: "Kimberly_en-US_neural",
    voice: "Kimberly",
    language: "en-US",
    label: "Kimberly (USA - English - Neural)",
    defaultVoice: false,
    engine: "neural",
  },
  {
    id: "Salli_en-US_neural",
    voice: "Salli",
    language: "en-US",
    label: "Salli (USA - English - Neural)",
    defaultVoice: false,
    engine: "neural",
  },
  {
    id: "Joey_en-US_neural",
    voice: "Joey",
    language: "en-US",
    label: "Joey (USA - English - Neural)",
    defaultVoice: false,
    engine: "neural",
  },
  {
    id: "Matthew_en-US_neural",
    voice: "Matthew",
    language: "en-US",
    label: "Matthew (USA - English - Neural)",
    defaultVoice: false,
    engine: "neural",
  },
  {
    id: "Matthew_en-US_generative",
    voice: "Matthew",
    language: "en-US",
    label: "Matthew (USA - English - Generative)",
    defaultVoice: false,
    engine: "generative",
  },
  {
    id: "Olivia_en-AU_neural",
    voice: "Olivia",
    language: "en-AU",
    label: "Olivia (Australia - English - Neural)",
    defaultVoice: false,
    engine: "neural",
  },
  {
    id: "Olivia_en-AU_generative",
    voice: "Olivia",
    language: "en-AU",
    label: "Olivia (Australia - English - Generative)",
    defaultVoice: false,
    engine: "generative",
  },
  {
    id: "Ruth_en-US_neural",
    voice: "Ruth",
    language: "en-US",
    label: "Ruth (USA - English - Neural)",
    defaultVoice: false,
    engine: "neural",
  },
  {
    id: "Ruth_en-US_generative",
    voice: "Ruth",
    language: "en-US",
    label: "Ruth (USA - English - Generative)",
    defaultVoice: true,
    engine: "generative",
  },
  {
    id: "Stephen_en-US_neural",
    voice: "Stephen",
    language: "en-US",
    label: "Stephen (USA - English - Neural)",
    defaultVoice: false,
    engine: "neural",
  },
  {
    id: "Stephen_en-US_generative",
    voice: "Stephen",
    language: "en-US",
    label: "Stephen (USA - English - Generative)",
    defaultVoice: false,
    engine: "generative",
  },
  {
    id: "Ayanda_en-ZA_neural",
    voice: "Ayanda",
    language: "en-ZA",
    label: "Ayanda (South Africa - English - Neural)",
    defaultVoice: false,
    engine: "neural",
  },
  {
    id: "Celine_fr-FR_neural",
    voice: "Celine",
    language: "fr-FR",
    label: "Celine (France - French - Neural)",
    defaultVoice: false,
    engine: "standard",
  },
  {
    id: "Mathieu_fr-FR_neural",
    voice: "Mathieu",
    language: "fr-FR",
    label: "Mathieu (France - French - Neural)",
    defaultVoice: false,
    engine: "standard",
  },
  {
    id: "Lea_fr-FR_neural",
    voice: "Lea",
    language: "fr-FR",
    label: "Lea (France - French - Neural)",
    defaultVoice: false,
    engine: "neural",
  },
  {
    id: "Remi_fr-FR_neural",
    voice: "Remi",
    language: "fr-FR",
    label: "Remi (France - French - Neural)",
    defaultVoice: false,
    engine: "neural",
  },
  {
    id: "Marlene_de-DE_neural",
    voice: "Marlene",
    language: "de-DE",
    label: "Marlene (Germany - German - Neural)",
    defaultVoice: false,
    engine: "standard",
  },
  {
    id: "Vicki_de-DE_neural",
    voice: "Vicki",
    language: "de-DE",
    label: "Vicki (Germany - German - Neural)",
    defaultVoice: false,
    engine: "neural",
  },
  {
    id: "Hans_de-DE_neural",
    voice: "Hans",
    language: "de-DE",
    label: "Hans (Germany - German - Neural)",
    defaultVoice: false,
    engine: "standard",
  },
  {
    id: "Daniel_de-DE_neural",
    voice: "Daniel",
    language: "de-DE",
    label: "Daniel (Germany - German - Neural)",
    defaultVoice: false,
    engine: "neural",
  },
  {
    id: "Seoyeon_ko-KR_neural",
    voice: "Seoyeon",
    language: "ko-KR",
    label: "Seoyeon (Korea - Korean - Neural)",
    defaultVoice: false,
    engine: "neural",
  },
  {
    id: "Takumi_ja-JP_neural",
    voice: "Takumi",
    language: "ja-JP",
    label: "Takumi (Japan - Japanese - Neural)",
    defaultVoice: false,
    engine: "neural",
  },
  {
    id: "Kazuha_ja-JP_neural",
    voice: "Kazuha",
    language: "ja-JP",
    label: "Kazuha (Japan - Japanese - Neural)",
    defaultVoice: false,
    engine: "neural",
  },
  {
    id: "Tomoko_ja-JP_neural",
    voice: "Tomoko",
    language: "ja-JP",
    label: "Tomoko (Japan - Japanese - Neural)",
    defaultVoice: false,
    engine: "neural",
  },
];

export const FEEDBACK_SATISFACTION = ["Yes", "No"];

export const FEEDBACK_COMPLETED = {
  ALL: "all",
  TRUE: "true",
  FALSE: "false",
};

/**
 * Makes an option from a value
 */
export function makeOption(value: string): OptionDefinition {
  return {
    label: value,
    value: value,
  };
}

/**
 * Return options sorted ascending by label
 */
export function makeOptions(input: string[]): OptionDefinition[] {
  const options: OptionDefinition[] = [];

  if (Array.isArray(input)) {
    input.forEach((value) => {
      options.push(makeOption(value));
    });
  }

  options.sort(function (o1, o2) {
    return o1.label.localeCompare(o2.label);
  });

  return options;
}

export function makeRadioItems(input: string[]) {
  const items: RadioGroupProps.RadioButtonDefinition[] = [];

  if (Array.isArray(input)) {
    input.forEach((value) => {
      items.push({
        label: value,
        value: value,
        controlId: value,
      });
    });
  }

  return items;
}

/**
 * Extracts values from an option array
 */
export function extractValues(selectedOptions: OptionDefinition[]) {
  const values: string[] = [];

  selectedOptions.forEach((option) => {
    values.push(option.value);
  });

  return values;
}

/**
 * Generic function for static content options
 */
async function createStaticContentOptionsAsync(
  getOptionsFunc: () => Promise<string[]>,
  fallbackOptions: string[],
  errorMessage: string
) {
  try {
    const dynamicOptions = await getOptionsFunc();
    return makeOptions(dynamicOptions);
  } catch (error) {
    console.warn(errorMessage, error);
    return makeOptions(fallbackOptions);
  }
}

/**
 * Supported Languages for demos (dynamic)
 */
export async function supportedLanguageOptionsAsync() {
  return createStaticContentOptionsAsync(
    languageOptionsModel.getOptions,
    LANGUAGES,
    "Failed to load dynamic languages, using fallback"
  );
}

/**
 * Supported Languages for demos (static fallback)
 */
export function supportedLanguageOptions() {
  return makeOptions(LANGUAGES);
}

/**
 * Supported demo types
 */
export function supportedDemoTypeOptions() {
  return makeOptions(DEMO_TYPES);
}

/**
 * Supported formats for demos
 */
export function supportedDemoFormatOptions() {
  return makeOptions(DEMO_FORMATS);
}

/**
 * Supported verticals for demos (dynamic)
 */
export async function supportedVerticalOptionsAsync() {
  return createStaticContentOptionsAsync(
    verticalOptionsModel.getOptions,
    VERTICALS,
    "Failed to load dynamic verticals, using fallback"
  );
}

/**
 * Supported verticals for demos (static fallback)
 */
export function supportedVerticalOptions() {
  return makeOptions(VERTICALS);
}

/**
 * Supported verticals for demos
 */
export function supportedCategoryOptions() {
  return makeOptions(CATEGORY_OPTIONS);
}

/**
 * Supported cognito groups
 */
export function supportedGroupsOptions() {
  return makeOptions(SUPPORTED_GROUPS);
}

/**
 * Supported verticals for demos
 */
export function supportedRoadmapStatusOptions() {
  return makeOptions(ROADMAP_STATUSES);
}

/**
 * Supported feedback type for feedback requests
 */
export function supportedFeedbackTypeOptions() {
  return makeOptions(FEEDBACK_TYPE);
}

/**
 * Supported services and features (dynamic)
 */
export async function supportedServicesAndFeaturesAsync() {
  return createStaticContentOptionsAsync(
    servicesAndFeaturesModel.getOptions,
    SERVICES_AND_FEATURES,
    "Failed to load dynamic services, using fallback"
  );
}

/**
 * Supported services and features (static fallback)
 */
export function supportedServicesAndFeaturesOptions() {
  return makeOptions(SERVICES_AND_FEATURES);
}

/**
 * Supported feedback satisfaction for feedback requests
 */
export function supportedFeedbackSatisfactionItems(): RadioGroupProps.RadioButtonDefinition[] {
  return makeRadioItems(FEEDBACK_SATISFACTION);
}

export function supportedFeedbackCompletedOptions() {
  return makeOptions(Object.values(FEEDBACK_COMPLETED));
}

export function supportedPollyVoicesOptions() {
  const options: OptionDefinition[] = [];

  const newVoices: PollyVoice[] = clone(POLLY_VOICES);

  newVoices.sort(function (v1: any, v2: any) {
    return v1.label.localeCompare(v2.label);
  });

  newVoices.forEach((voice) => {
    options.push({
      label: voice.label,
      value: voice.id,
    });
  });

  return options;
}

export function makePollyVoiceOption(id: string) {
  const voice = getPollyVoice(id);

  if (voice) {
    return {
      label: voice.label,
      value: voice.id,
    };
  } else {
    return undefined;
  }
}

export function getDefaultPollyVoice() {
  const defaultVoice = POLLY_VOICES.find((pv) => pv.defaultVoice === true);

  if (defaultVoice) {
    return {
      label: defaultVoice.label,
      value: defaultVoice.id,
    };
  } else {
    return undefined;
  }
}

/**
 * Fetches polly voice by id
 */
export function getPollyVoice(id: String) {
  const voice = POLLY_VOICES.find((pv) => pv.id === id);
  return voice;
}
